// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"3db9e096","513":"0cbc54cb","703":"c36dca4a","787":"6013aa69"}[chunkId] + ".chunk.js";
};